import { useQuery } from "@tanstack/react-query";
import i18n from "i18n";
import { Assistant } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
export const widgetSummaryAvailabilityQueryKey = (widgetType) => [
  "assistant",
  "widget-summary",
  widgetType,
  "availability"
];
const fetchAvailability = (widgetType) => Assistant.widgetSummaryAvailability(encodeURIComponent(widgetType)).then((response) => {
  var _a;
  return {
    available: response.available,
    message: (_a = response.message) != null ? _a : void 0
  };
});
const useWidgetSummaryAvailability = (widgetType) => {
  const { data, isLoading } = useQuery({
    queryKey: widgetSummaryAvailabilityQueryKey(widgetType),
    queryFn: () => defaultOnError(
      fetchAvailability(widgetType),
      i18n.t("notifications.widget_summary_availability_message", { ns: "enterprise_ai" }),
      i18n.t("notifications.widget_summary_availability_title", { ns: "enterprise_ai" })
    )
  });
  return { data: data != null ? data : { available: false, message: void 0 }, isLoading };
};
export default useWidgetSummaryAvailability;
